import { ReactElement } from 'react';
import { useSite } from 'context/SiteContext';
import {
  DateOnlyISOString,
  formatISOStringToSiteLocaleDate,
} from 'utils/dateUtil';
import {
  AppointmentsPrintHeaderLogo,
  AppointmentsPrintHeaderSiteInfo,
  AppointmentsPrintHeaderWrapper,
} from './AppointmentsPrintHeader.styled';

type Props = {
  selectedDate: DateOnlyISOString;
};

export const AppointmentsPrintHeader = ({
  selectedDate,
}: Props): ReactElement => {
  const {
    activeSite: { name: siteName },
  } = useSite();

  return (
    <AppointmentsPrintHeaderWrapper>
      <AppointmentsPrintHeaderLogo />
      <AppointmentsPrintHeaderSiteInfo>
        <div>{siteName}</div>
        <div>{formatISOStringToSiteLocaleDate(selectedDate)}</div>
      </AppointmentsPrintHeaderSiteInfo>
    </AppointmentsPrintHeaderWrapper>
  );
};
